import _ from 'lodash';
import $ from 'jquery';

var $window = $(window);

export default class StickyNav {
  constructor(element, options) {
    this.$el = $(element);
    this.options = _.extend({
      $collapse: null,
      collapsable: false,
      anchor: false,
      stickyBottom: false,
      inset: 0
    }, options);

    this._validateOptions(this.options);
    _.extend(this, this.options);
    this._initialize();
  }

  _validateOptions(options) {
    if (!this.$el.length) {
      throw new Error('StickyNav requires a valid element');
    }
    if (!options.$container || !options.$container.length) {
      throw new Error('StickyNav requires a jQuery container');
    }
    return true;
  }

  _initialize() {
    _.bindAll(this, '_handleScroll');
    this._makeClone();

    this.ui = {
      clone: this.$el.next('.cloned')
    };

    this.lastScrollTop = 0;

    if (this.anchor) {
      this.sections = this._gatherContentSections();
    }

    if (this.stickyBottom) {
      this.stick();
    }

    $window.on('scroll', this._handleScroll).trigger('scroll');

    if (this.$collapse != null) {
      this.collapsable = true;
      this.secondaryPadding = parseInt($('.secondary .content-area').css('paddingTop'), 10);
      this.ui.clone.on('mouseenter', this.$collapse, this._handleEnter);
    }
  }

  _makeClone() {
    var clone = this.$el.clone();
    this.$el.addClass('original');
    clone.addClass('cloned').insertAfter(this.$el);
  }

  _gatherContentSections() {
    return this.$el.find('a').not('.no-section').map(function () {
      var href = $(this).attr('href');
      if (href && href.indexOf('#') >= 0) {
        var id = href.substring(href.indexOf('#')),
          item = $(id);
        if (item.length) {
          return item;
        }
      }
    });
  }

  unstick() {
    this.$el.css('visibility', 'visible');
    this.ui.clone.css('display', 'none').toggleClass('stick', false);
  }

  stick() {
    this.$el.css('visibility', 'hidden');
    this.ui.clone.css('display', 'block').toggleClass('stick', true);
  }

  overflow() {
    this.ui.clone.css('display', 'none').toggleClass('stick', false);
  }

  _highlightCurrentSection(scrollPos) {
    var fromTop = scrollPos + this.$el.height() + this.inset,
      visible = this.sections.map(function () {
        if (this.offset().top < fromTop) {
          return this;
        }
      }),
      current = _.last(visible),
      id = (current) ? current.attr('id') : '';

    if (id.length > 0) {
      this.ui.clone.find('a').each(function () {
        var isActive = ($(this).attr('href').indexOf('#' + id) >= 0);
        $(this).parent().toggleClass('current', isActive);
      });
    }
  }

  _handleScroll() {
    var scrolled = $window.scrollTop(),
      target = this.$el.offset().top - this.inset,
      over = this.$container.offset().top + this.$container.height() - this.ui.clone.height();

    if (this.stickyBottom) {
      if (scrolled + window.innerHeight >= this.$container.offset().top + this.$container.height()) {
        this.unstick();
      } else {
        this.stick();
      }
    } else {
      if (scrolled >= target) {
        if (scrolled >= over) {
          this.overflow();
        } else {
          this.stick();
          if (this.anchor) {
            this._highlightCurrentSection(scrolled);
          }
        }
      } else {
        this.unstick();
      }
    }

    if (this.collapsable) {
      if (scrolled > this.lastScrollTop) {
        if (scrolled >= target + $(this.$collapse).outerHeight()) {
          var move = this.lastScrollTop - scrolled;
          this._handleScrollDown(move);
        }
      } else {
        this._handleScrollUp();
      }

      if (scrolled === 0) this._handleScrollTop();
      if (scrolled + $window.height() === $(document).height()) this._handleScrollUp();
    }

    this.lastScrollTop = scrolled;
  }

  _handleEnter() {
    var nav = $(this).closest('.cloned');
    if (nav.is(':visible')) {
      nav.animate({top: 0}, 600);
    }
  }

  _handleScrollUp() {
    if (this.ui.clone.is(':visible')) {
      this.ui.clone.animate({top: 0}, 600);
    }
  }

  _handleScrollDown(moved) {
    if (this.ui.clone.is(':visible')) {
      var top = parseInt(this.ui.clone.css('top'), 10),
        offset = top + moved,
        maxOffset = ($(this.$collapse).outerHeight() - 3) * -1;

      if (offset < maxOffset) offset = maxOffset;
      this.ui.clone.stop(true, true).css('top', offset + 'px');

      if (!_.isNull(this.secondaryPadding)) {
        var padding = parseInt($('.secondary .content-area').css('paddingTop'), 10);
        if (padding > 5) {
          padding = (padding / 2 > 5) ? padding / 2 : 5;
          $('.secondary .content-area').css('paddingTop', padding);
        }
      }
    }
  }

  _handleScrollTop() {
    if (!_.isNull(this.secondaryPadding)) {
      $('.secondary .content-area').css('paddingTop', this.secondaryPadding);
    }
  }
}
